const storeCookieName = 'pxg_preferred_store';
const cookieDurationDays = 30;

function getStoreCookie() {
  const value = document.cookie.split('; ').find((row) => row.startsWith(`${storeCookieName}=`));
  return value ? decodeURIComponent(value.split('=')[1]) : null;
}

function setStoreCookie(objectValue, days = cookieDurationDays) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const cookieValue = encodeURIComponent(JSON.stringify(objectValue));
  document.cookie = `${storeCookieName}=${cookieValue};${expires};path=/`;
}

function getStoreFromCookie() {
  const cookie = getStoreCookie();
  try {
    return cookie ? JSON.parse(cookie) : null;
  } catch (e) {
    console.warn('PXG Stores: failed to parse store cookie:', e);
    return null;
  }
}

// Update the Fitting Locations text and link in upper nav
function updateLocationUI(storeName, storeLat, storeLong, closestStoreGeolocated = false) {
  if (!window.featureToggle.preferredStoreUXEnabled) {
    // console.log('PXG Stores: disabled');
    return;
  }
  const locationLink = document.querySelector('.location-link');
  if (locationLink && storeLat && storeLong) {
    const baseUrl = locationLink.href.split('#')[0].split('?')[0];
    locationLink.href = `${baseUrl}?search=${encodeURIComponent(`${storeLat},${storeLong}`)}#locations-component`;

    locationLink.classList.remove('text-fairway');
    locationLink.classList.add('text-sunset');

    const textFields = locationLink.querySelectorAll('.locations-text');
    textFields.forEach((field) => {
      field.textContent = storeName;

      field.classList.remove('text-fairway');
      field.classList.add('text-sunset');
    });
  }
  if (closestStoreGeolocated) {
    const icon = locationLink.querySelector('svg');
    const textFields = locationLink.querySelectorAll('.locations-text');

    if (icon) {
      icon.classList.add('animate-pulse');
    }
    textFields.forEach((field) => {
      field.classList.add('animate-pulse');
    });

    // remove the animation class after 2 seconds
    setTimeout(() => {
      if (icon) {
        icon.classList.remove('animate-pulse');
      }
      textFields.forEach((field) => {
        field.classList.remove('animate-pulse');
      });
    }, 4000);
  }
}

// Make updateLocationUI and setStoreCookie available to SchedulerApp
window.updateLocationUI = updateLocationUI;
window.setStoreCookie = setStoreCookie;

// Run the geolocation script when the DOM is loaded
document.addEventListener('DOMContentLoaded', async () => {
  const storeData = getStoreFromCookie();

  // We know the user is not near any stores, returning
  if (storeData?.name === 'n/a') {
    // console.log('PXG Stores: user is not near any stores');
    return;
  }

  // If the cookie holding closest store data exists, update the DOM immediately and return
  if (storeData?.name) {
    // console.log('PXG Stores: using cached closest store:', storeData);
    updateLocationUI(storeData.name, storeData.latitude, storeData.longitude);
    return;
  }

  // Otherwise - proxy API request for closest PXG store within 50 miles
  try {
    // console.log('PXG Stores: fetching closest store, this should only happen once per session');
    const response = await fetch('/apps/pxg/v1/store-geolocation', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Closest store geolocation response was not ok. Response status: ${response.status}`);
    }

    const data = await response.json();
    if (data.message === 'Closest store within radius found' && data.store) {
      // Save closest store data to cookie
      setStoreCookie({
        name: data.store.name,
        latitude: data.store.latitude,
        longitude: data.store.longitude,
      });
      updateLocationUI(data.store.name, data.store.latitude, data.store.longitude, true);
    } else {
      // If no store is found within radius, set the cookie to empty so we don't keep trying to geolocate
      // console.log('PXG Stores: No store found within radius, setting cookie to empty');
      setStoreCookie({
        name: 'n/a',
        latitude: '',
        longitude: '',
      });
    }
  } catch (err) {
    console.error('PXG Stores error:', err);
  }
});
